import animateOnScroll from "../../utils/animateOnScroll";

const landingInstallationAnimation = () => {

    const canvas = document.getElementById("lun-build-canvas");
    const context = canvas.getContext("2d");
    canvas.width = 800;
    canvas.height = 577;
    const frameCount = 60;
    const currentFrame = index => (
        `../../wp-content/themes/p-sec-products/assets/images/lun-build/${(index + 1).toString().padStart(4, '0')}.png`
    );
    const images = []
    const lun = {
        frame: 0
    };

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = currentFrame(i);
        images.push(img);
    }

    let tl = gsap.timeline({
        scrollTrigger:{
            trigger: '.landing-installation__wrapper',
            start: "top 25%",
            toggleActions: "play none none reverse",
            end: "top top",
        }
    })

    tl.to(lun, {
        frame: frameCount - 1,
        duration: 1.3,
        snap: "frame",
        ease: "power3.easeOut",
        onUpdate: render
    },0);

    images[0].onload = render;
    function render() {
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(images[lun.frame], 0, 0);
    }

    $(window).on('scroll', () => {
        animateOnScroll('.js-installation');
    })
    $(window).trigger('scroll')
}


export default landingInstallationAnimation;